import { api } from '@/core/helpers/axiosHelper';
import { CandidatePool } from './candidate-pool.interface';

export default {
   async postBulk(body: Partial<CandidatePool>) {
      return await api.post('/candidate-pool/bulk', body).then((response) => response.data);
   },
};
